export interface SimpleHorizontalListWidgetConfigData {
	backgroundColorType?: SimpleHorizontalListBgColorType;
	cardAppearanceType?: SimpleHorizontalListAppearanceType;
	titleSize?: SimpleHorizontalListTitleSize;
	isEditable?: boolean;
}

export enum SimpleHorizontalListBgColorType {
	Default = "default",
	Grey = 'grey'
}

export enum SimpleHorizontalListAppearanceType {
	Outlined = "outlined",
	Raised = 'raised'
}

export enum SimpleHorizontalListTitleSize {
	Default = "default",
	Small = 'small',
	ExtraSmall = 'extraSmall'
}
